import personalMana from './personalMana'
import edit from './edit'
import auth from './auth'
import authBatch from './authBatch'

const zhCN = {
  personalMana: personalMana.zhCN,
  personalManaEdit: edit.zhCN,
  personalManaAuth: auth.zhCN,
  personalManaAuthBatch: authBatch.zhCN
}
const enUS = {
  personalMana: personalMana.enUS,
  personalManaEdit: edit.enUS,
  personalManaAuth: auth.enUS,
  personalManaAuthBatch: authBatch.enUS
}
export default { zhCN, enUS }